/* ------------------------------------------------------------------
   Repair window.cartStrings.

   The theme emits this object from an inline script, filled from
   locales/ar.json. Two of its entries are broken by the machine
   translation, and both only surface at the worst possible moment — when a
   customer is trying to add something to the cart:

     cartErrorMessage: `Translation missing: ar.sections.cart.cart_quantity_error_prefix`
     quantityError:    `يمكنك فقط إضافة [الكمية] من هذا المنتج إلى سلة التسوق الخاصة بك.`

   The first renders the raw i18n key to the customer. The second is subtler:
   the translator also translated the *placeholder token*. The theme
   substitutes a number into `[quantity]` (its sibling addProductOutQuantity
   still uses the untranslated `[maxQuantity]` and works), so `[الكمية]` is
   never matched and the shopper is shown literal brackets instead of a
   number.

   Both replacements are written without any placeholder token so they cannot
   break the same way again, and the wording is chosen to still be useful
   without naming a quantity.

   This runs as its own asset rather than inside portafoto-live-fixes.js
   because it must patch a global that an inline script created, and keeping
   it separate makes the ordering obvious: deferred scripts run after inline
   ones, so window.cartStrings always exists by the time this executes.
   ------------------------------------------------------------------ */
(() => {
  'use strict';

  const EN = window.PortafotoLang === 'en';

  const COPY = EN ? {
    cartError: 'Something went wrong updating your cart. Please try again.',
    quantityError: 'We have fewer of this item in stock than you asked for.',
    items: 'items',
    item: 'item'
  } : {
    cartError: 'حصلت مشكلة وإحنا بنحدّث السلة. جرّب تاني.',
    quantityError: 'الكمية المتاحة من المنتج ده أقل من اللي طلبته.',
    items: 'منتجات',
    item: 'منتج'
  };

  const patch = () => {
    const s = window.cartStrings;
    if (!s || s.__pfPatched) return !!s;

    if (typeof s.cartErrorMessage === 'string' && /^Translation missing:/.test(s.cartErrorMessage)) {
      s.cartErrorMessage = COPY.cartError;
    }
    // Any other key that failed to resolve would also render raw to the customer.
    Object.keys(s).forEach((k) => {
      if (typeof s[k] === 'string' && /^Translation missing:/.test(s[k])) s[k] = COPY.cartError;
    });

    if (typeof s.quantityError === 'string' && s.quantityError.indexOf('[الكمية]') !== -1) {
      s.quantityError = COPY.quantityError;
    }

    // "غرض" means "a purpose", not an item.
    if (s.items === 'أغراض') s.items = COPY.items;
    if (s.item === 'غرض') s.item = COPY.item;

    s.__pfPatched = true;
    return true;
  };

  if (!patch()) {
    /* The inline script normally runs first, but a slow or re-ordered load
       could leave the global undefined — retry briefly rather than silently
       giving up on a customer-facing error message. */
    let tries = 0;
    const timer = setInterval(() => {
      if (patch() || (tries += 1) > 20) clearInterval(timer);
    }, 100);
  }
})();
